import { Component, Input, OnChanges } from "@angular/core";

@Component({
    selector: "ticket-state-badge",
    template: `
        <span class="ticket-state-badge"
              [matTooltip]="closedException ? ('CLOSED_WITH_FINDINGS_ON' | localize: (closedOn | longDate))
                            : ('CLOSED_ON' | localize: (closedOn|longDate))"
              [matTooltipDisabled]="!closedOn"
              [class.is-closed]="state === 'Closed'">
            {{ currState }}
            <span *ngIf="closedException">
                <i class="far fa-info-circle"></i>
            </span>
        </span>
    `,
})
export class TicketStateBadgeComponent implements OnChanges {
    @Input() state: string;
    @Input() closedOn: string;
    @Input() closedException: boolean;
    currState: string;

    ngOnChanges() {
        this.currState = this.state?.replace("_", " ");
    }
}
